module.exports = __webpack_public_path__ + "img/left-4.95170af6.png";